import React, { useState } from "react";

const Contactpage = () => {
  const [forms, setForms] = useState({
    name: "",
    email: "",
     mobile: "", 
    address: "",
    service: "",
    note: "",
  });

  // ✅ ADD ONLY THESE TWO STATES
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const changeHandler = (e) => {
    setForms({ ...forms, [e.target.name]: e.target.value });
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    // reset messages
    setSuccessMsg("");
    setErrorMsg("");

    try {
      const res =  await fetch("/api/contact/send", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...forms,
          source: "contact-page",
        }),
      });

      const data = await res.json();

      if (data.success) {
        setSuccessMsg("Thank you! We will contact you shortly.");

        setForms({
          name: "",
          email: "",
           mobile: "", 
          address: "",
          service: "",
          note: "",
        });

        // auto-hide success after 5 sec
        setTimeout(() => setSuccessMsg(""), 5000);
      } else {
        setErrorMsg(data.message || "Submission failed");
      }
    } catch (err) {
      setErrorMsg("Server error. Please try again later.");
    }
  };

  return (
    <section className="wpo-contact-pg-section section-padding pt-0">
      <div className="container">
        <div className="row">
          <div className="col col-lg-10 offset-lg-1">

            {/* --- YOUR EXISTING FORM (UNCHANGED) --- */}
            <div className="wpo-contact-form-area">
              <form onSubmit={submitHandler} className="contact-validation-active">
                <div>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={forms.name}
                    onChange={changeHandler}
                    placeholder="Your Name*"
                  />
                </div>

                <div>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={forms.email}
                    onChange={changeHandler}
                    placeholder="Your Email*"
                  />
                </div>
               <div>
  <input
    type="tel"
    className="form-control"
    name="mobile"
    value={forms.mobile}
    onChange={changeHandler}
    placeholder="Mobile Number*"
    required
  />
</div>

                <div>
                  <input
                    type="text"
                    className="form-control"
                    name="address"
                    value={forms.address}
                    onChange={changeHandler}
                    placeholder="Address"
                  />
                </div>

                <div>
                  <select
                    name="service"
                    className="form-control"
                    value={forms.service}
                    onChange={changeHandler}
                  >
                    <option value="">Select Service</option>
                    <option>Architectural</option>
                    <option>Interiors</option>
                    <option>Design & Planning</option>
                  </select>
                </div>

                <div className="fullwidth">
                  <textarea
                    className="form-control"
                    name="note"
                    value={forms.note}
                    onChange={changeHandler}
                    placeholder="Message..."
                  />
                </div>

                <div className="submit-area">
                  <button type="submit" className="theme-btn">
                    Get in Touch
                  </button>
                </div>

                {/* ✅ SUCCESS MESSAGE (GREEN, BELOW FORM) */}
                {successMsg && (
                  <div
                    style={{
                      marginTop: "15px",
                      padding: "12px",
                      backgroundColor: "#e6f7ee",
                      color: "#1e7e34",
                      border: "1px solid #b7ebcd",
                      borderRadius: "4px",
                      textAlign: "center",
                      fontWeight: "500",
                    }}
                  >
                    {successMsg}
                  </div>
                )}

                {/* ❌ ERROR MESSAGE (RED, BELOW FORM) */}
                {errorMsg && (
                  <div
                    style={{
                      marginTop: "15px",
                      padding: "12px",
                      backgroundColor: "#fdecea",
                      color: "#a94442",
                      border: "1px solid #f5c6cb",
                      borderRadius: "4px",
                      textAlign: "center",
                    }}
                  >
                    {errorMsg}
                  </div>
                )}
              </form>
            </div>
            {/* --- END FORM --- */}

          </div>
        </div>
      </div>
    </section>
  );
};

export default Contactpage;
